var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 71,
    viewBox: "0 0 152 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8457 43.8729C25.5837 39.2522 48.182 35.6748 75.6659 35.6748C103.15 35.6748 125.761 39.2522 128.493 43.8664C128.36 44.5871 128.169 45.2959 127.922 45.9856C123.477 59.271 101.774 69.3485 75.6594 69.3485C49.5445 69.3485 27.8546 59.271 23.4102 46.018C23.1664 45.3187 22.9776 44.6015 22.8457 43.8729Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6723 61.9024C116.913 61.9024 150.345 51.1465 150.345 37.8784C150.345 24.6104 116.913 13.8545 75.6723 13.8545C34.4319 13.8545 1 24.6104 1 37.8784C1 51.1465 34.4319 61.9024 75.6723 61.9024Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6723 58.5713C116.913 58.5713 150.345 47.8154 150.345 34.5474C150.345 21.2793 116.913 10.5234 75.6723 10.5234C34.4319 10.5234 1 21.2793 1 34.5474C1 47.8154 34.4319 58.5713 75.6723 58.5713Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.974 26.4852C102.54 31.1383 90.4005 34.7027 75.6788 34.7027C60.9571 34.7027 48.8437 31.1383 47.3904 26.4917C47.4618 25.7723 47.5656 25.0659 47.6953 24.3725C48.8781 17.8169 52.3293 11.8848 57.4461 7.61266C62.5628 3.34053 69.0196 1 75.6885 1C82.3574 1 88.8143 3.34053 93.931 7.61266C99.0477 11.8848 102.499 17.8169 103.682 24.3725C103.799 25.0594 103.902 25.7658 103.974 26.4852Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.123 25.5518C104.122 25.8687 104.072 26.1836 103.974 26.485C102.54 31.1382 90.4005 34.7026 75.6789 34.7026C60.9572 34.7026 48.8438 31.1382 47.3904 26.4915C47.2925 26.1901 47.2421 25.8752 47.2412 25.5583C47.2424 25.0676 47.3579 24.5839 47.5786 24.1455L47.6954 24.3723C50.0895 28.6366 61.7163 31.877 75.6918 31.877C89.6674 31.877 101.288 28.6366 103.682 24.3723L103.799 24.1455C104.014 24.583 104.125 25.0643 104.123 25.5518Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.14111 40.2697C3.14111 40.2697 22.9754 28.0147 47.3904 27.25",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.353 40.2697C148.353 40.2697 128.492 28.0147 104.123 27.25",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4038 34.0288C93.5022 40.1255 98.6845 48.1422 101.327 57.1131",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5266 34.0288C56.429 40.1263 51.2468 48.1426 48.6038 57.1131",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6724 51.0145C78.643 51.0145 81.0511 48.6092 81.0511 45.642C81.0511 42.6749 78.643 40.2695 75.6724 40.2695C72.7018 40.2695 70.2937 42.6749 70.2937 45.642C70.2937 48.6092 72.7018 51.0145 75.6724 51.0145Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M133.512 24.8685C133.859 23.428 131.597 21.6477 128.458 20.8921C125.319 20.1366 122.493 20.6919 122.146 22.1324C121.798 23.5729 124.061 25.3532 127.199 26.1088C130.338 26.8644 133.164 26.3091 133.512 24.8685Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4739 26.1084C26.6126 25.3528 28.8753 23.5725 28.5277 22.132C28.1801 20.6914 25.3539 20.1361 22.2152 20.8917C19.0765 21.6473 16.8139 23.4276 17.1614 24.8681C17.509 26.3086 20.3352 26.8639 23.4739 26.1084Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M119.565 43.8565C120.931 41.9837 119.64 38.721 116.683 36.5692C113.725 34.4173 110.22 34.1911 108.855 36.064C107.489 37.9368 108.779 41.1995 111.737 43.3513C114.695 45.5032 118.199 45.7294 119.565 43.8565Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0712 43.2895C43.0271 41.1483 44.3217 37.8951 42.9627 36.0234C41.6037 34.1516 38.1058 34.37 35.1499 36.5112C32.194 38.6524 30.8994 41.9055 32.2584 43.7773C33.6174 45.6491 37.1153 45.4306 40.0712 43.2895Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.624 20.3415C102.624 20.3415 106.199 14.1395 113.654 13.8608",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6296 20.3415C48.6296 20.3415 45.0546 14.1395 37.5997 13.8608",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUfo);
export default __webpack_public_path__ + "static/media/ufo.1b5aaa186a7ab4f3496593c9bda65b96.svg";
export { ForwardRef as ReactComponent };